import { giphyBlack, giphyIndigo, giphyWhite } from '@giphy/js-brand'
import React from 'react'
import styled from 'styled-components'
import { IChannel } from 'shared/types/channel'

const fontSize = 15
const Container = styled.div`
    display: flex;
    font-family: 'interface', Helvetica Neue, helvetica, sans-serif;
    font-weight: bold;
    overflow-y: auto;
    flex-wrap: nowrap;
    font-size: ${fontSize}px;
`
const Pill = styled.div<{ isCommon?: boolean }>`
    color: ${giphyWhite};
    border: 1px solid ${props => (props.isCommon === false ? 'transparent' : giphyIndigo)};
    padding: 13px;
    border-radius: 6px;
    margin-right: 10px;
    white-space: nowrap;
    display: flex;
    align-content: center;
    background: ${giphyBlack};
    user-select: none;
    span {
        cursor: pointer;
        margin: 2px 0 0 10px;
        font-size: 12px;
    }
`

type Props = {
    collections: IChannel[]
    onDelete: (channel: IChannel) => void
}

const EditCollectionPills = ({ collections = [], onDelete }: Props) => {
    return (
        <Container>
            {collections.map(collection => {
                const { id, display_name, slug, is_common } = collection
                return (
                    <Pill key={id} isCommon={is_common}>
                        {display_name || slug}
                        <span className="ss-delete" onClick={() => onDelete(collection)} />
                    </Pill>
                )
            })}
        </Container>
    )
}

export default EditCollectionPills
